export const normalizeSearchMetadata = value => {
  const entries = Array.isArray(value)
    ? value
    : String(value ?? "").split(/[\n,]/);

  const seen = new Set();

  return entries.reduce((normalized, entry) => {
    const cleanEntry = String(entry ?? "")
      .trim()
      .replace(/\s+/g, " ");
    const comparisonKey = cleanEntry.toLocaleLowerCase();

    if (!cleanEntry || seen.has(comparisonKey)) { return normalized; }

    seen.add(comparisonKey);
    normalized.push(cleanEntry);
    return normalized;
  }, []);
};

export const searchMetadataText = value =>
  normalizeSearchMetadata(value).join("\n");
